import { SharedState } from '@trello/shared-state';

export type SortBy = 'dateLastActivity' | 'name';
export type SortOrder = 'asc' | 'desc';
export type SortKey =
  | 'alphabetical-a-z'
  | 'alphabetical-z-a'
  | 'least-recent'
  | 'most-recent';

export const sortMap: {
  [key in SortKey]: { sortBy: SortBy; sortOrder: SortOrder };
} = {
  'most-recent': {
    sortBy: 'dateLastActivity',
    sortOrder: 'desc',
  },
  'least-recent': {
    sortBy: 'dateLastActivity',
    sortOrder: 'asc',
  },
  'alphabetical-a-z': {
    sortBy: 'name',
    sortOrder: 'asc',
  },
  'alphabetical-z-a': {
    sortBy: 'name',
    sortOrder: 'desc',
  },
};

export interface WorkspaceBoardsFilterStateType {
  limit: number;
  tagFilter: string | null;
  searchQuery: string;
  sort: SortKey;
  sortBy: SortBy;
  sortOrder: SortOrder;
}

export const workspaceBoardsFilterState =
  new SharedState<WorkspaceBoardsFilterStateType>({
    limit: 28,
    tagFilter: null,
    searchQuery: '',
    sort: 'most-recent',
    sortBy: 'dateLastActivity',
    sortOrder: 'desc',
  });
